import Vue from "vue";
import Vuex from "vuex";
import UAParser from "ua-parser-js";
import statics from "./statics";
import userInfo from "./userInfo";
import interaction from "./interaction";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    nowTime: new Date(),
    Parser: UAParser(),
    isMobile: !!navigator.userAgent.match(/(iPhone|iPod|Android|ios)/i), //当前是不是wap
    isAndroid:
      ((navigator.userAgent.indexOf("Android") > -1 ||
        navigator.userAgent.indexOf("Adr") > -1) &&
        navigator.userAgent.indexOf("WeChat") > -1) ||
      ((navigator.userAgent.indexOf("Android") > -1 ||
        navigator.userAgent.indexOf("Adr") > -1) &&
        navigator.userAgent.indexOf("Huawei") > -1), //android终端
    isIOS: !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //是否为ios终端
    isXiaoMi: navigator.userAgent.indexOf("XiaoMi") > -1,
    isIE: !!window.ActiveXObject || "ActiveXObject" in window,
    isMiniProgram: true,
  },
  getters: {},
  mutations: {
    updateMiniProgram(state, val) {
      state.isMiniProgram = val;
    },
  },
  actions: {},
  modules: {
    statics,
    userInfo,
    interaction,
  },
});
